import { render, staticRenderFns } from "./ZDMLanternPatternsTab.vue?vue&type=template&id=7bc4a831&scoped=true&"
import script from "./ZDMLanternPatternsTab.vue?vue&type=script&lang=js&"
export * from "./ZDMLanternPatternsTab.vue?vue&type=script&lang=js&"
import style0 from "./ZDMLanternPatternsTab.vue?vue&type=style&index=0&id=7bc4a831&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc4a831",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VList,VListItem,VListItemAction,VListItemContent,VListItemTitle,VRow,VTooltip})
